import type { ChangeEvent } from 'react';
import { Radio, RadioGroup } from '@ksyos/design-system';
import { useState } from 'react';
import { translateKey } from '../../../../../translate';

interface ISettingsCanWriteProps {
    canWrite: boolean;
    enabled: boolean;
    error?: string;
    onChange: (canWrite: boolean, enabled: boolean) => void;
}

type TCanWriteOptions = 'none' | 'read' | 'readAndWrite';

export function SettingsCanWrite(props: ISettingsCanWriteProps) {
    const [rights, setRights] = useState<TCanWriteOptions>(getInitialRights());

    return (
        <RadioGroup
            error={props.error}
            layout="row"
            onChange={onChange}
            value={rights}
        >
            <Radio
                label={translateKey('common.none')}
                value="none"
            />
            <Radio
                label={translateKey('common.readOnly')}
                value="read"
            />
            <Radio
                label={translateKey('common.readAndWrite')}
                value="readAndWrite"
            />
        </RadioGroup>
    );

    function onChange({ target: { value } }: ChangeEvent<HTMLInputElement>) {
        if (value === 'none') {
            props.onChange(false, false);
        }
        if (value === 'read') {
            props.onChange(false, true);
        }
        if (value === 'readAndWrite') {
            props.onChange(true, true);
        }

        setRights(value as TCanWriteOptions);
    }

    function getInitialRights(): TCanWriteOptions {
        if (props.enabled && props.canWrite) {
            return 'readAndWrite';
        }

        return props.enabled ? 'read' : 'none';
    }
}
